import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var InputWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  gap: ", "px;\n"], ["\n  display: flex;\n  justify-content: center;\n  gap: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs;
});
var ZipCodeInputBox = styled.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  font-weight: ", ";\n  border: solid 1px\n    ", ";\n  border-radius: ", "px;\n  text-align: center;\n  background-color: ", ";\n  margin-left: ", ";\n\n  :focus {\n    border: solid 1px ", ";\n    outline: none;\n  }\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  @media (min-width: ", "px) {\n    width: ", "px;\n    height: ", "px;\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  font-weight: ", ";\n  border: solid 1px\n    ", ";\n  border-radius: ", "px;\n  text-align: center;\n  background-color: ", ";\n  margin-left: ", ";\n\n  :focus {\n    border: solid 1px ", ";\n    outline: none;\n  }\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  @media (min-width: ", "px) {\n    width: ", "px;\n    height: ", "px;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.zipCodeInputSizeSmall;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.zipCodeInputSizeSmall;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.weight.semiBold;
}, function (props) {
  var _a, _b;

  return props.verified === false ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.dark : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.greenMedium;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxxs;
}, function (props) {
  var _a, _b;

  return props.verified === false ? props.backgroundColor ? props.backgroundColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white : props.verifiedBackground ? props.verifiedBackground : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.greenLight;
}, function (props) {
  var _a;

  return props.marginLeft ? "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.sm, "px") : 0;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.alertBlue;
}, function (props) {
  var _a, _b;

  return (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.xs;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.zipCodeInputSize;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.zipCodeInputSize;
});
var templateObject_1, templateObject_2;
export { InputWrapper, ZipCodeInputBox };